// Naive eTLD+1 (last two labels). Only ever compared against our own API hosts, which are all
// two-label (ahaslides.com/.eu, ahaslide.com, ahaslides.nl) — so it fails closed on multi-part TLDs.
// Don't reuse it as a general eTLD+1.
const registrableDomain = (hostname) => hostname.split('.').slice(-2).join('.')

// Mirrors config-env.js `ahaTokenCookie.rootDomains` — the only origins the API answers with
// Access-Control-Allow-Credentials. Anywhere else (localhost, IPs) it replies ACAO:* and the
// browser rejects a credentialed request outright, so the gate has to fail closed there.
const CREDENTIALED_DOMAINS = new Set(['ahaslides.com', 'ahaslide.com', 'ahaslides.eu', 'ahaslides.nl'])

// A cross-origin XHR carries the ahaToken cookie only if it's sent withCredentials AND answered with
// credentialed CORS, so this has to be true only where both hold. In practice that is EU alone
// (presenter2.ahaslides.eu -> api-*.eu01.ahaslides.eu); on .com and white-label the API is already
// same-origin, and moving a surface same-origin retires this for it.
export const shouldSendApiCredentials = (requestUrl, apiBaseUrl, pageHref) => {
  try {
    const reqHost = new URL(requestUrl, pageHref).hostname
    const apiHost = new URL(apiBaseUrl).hostname
    const pageHost = new URL(pageHref).hostname
    return reqHost === apiHost
      && CREDENTIALED_DOMAINS.has(registrableDomain(reqHost))
      && registrableDomain(reqHost) === registrableDomain(pageHost)
  } catch (e) {
    return false
  }
}
